import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Section from './Section';
import FEATURES from '../data/features';

const SHADOW = '4px 4px 0px #1e1e1e';

export default function FeaturesGrid() {
  return (
    <Section background="#FFFFFF" id="features">
      <Box sx={{ textAlign: 'center', mb: { xs: 5, md: 8 } }}>
        <Typography
          variant="h2"
          sx={{
            fontFamily: 'Montserrat, Inter, sans-serif',
            fontSize: { xs: '1.75rem', md: '2.5rem' },
            fontWeight: 800,
            color: '#2C2C2C',
            mb: 2,
          }}
        >
          Everything You Need to Inspire Young Writers
        </Typography>
        <Typography
          sx={{
            fontFamily: 'Lato, Inter, sans-serif',
            fontSize: { xs: '1rem', md: '1.15rem' },
            color: '#555',
            maxWidth: 600,
            mx: 'auto',
            lineHeight: 1.7,
          }}
        >
          AI-powered feedback meets proven writing pedagogy — across all subjects, grades 2-12, in 6+ languages.
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr', md: '1fr 1fr 1fr' },
          gap: 3,
        }}
      >
        {FEATURES.map((feature) => (
          <Box
            key={feature.title}
            sx={{
              p: { xs: 3, md: 4 },
              borderRadius: '6px',
              border: '2px solid #1e1e1e',
              boxShadow: SHADOW,
              backgroundColor: '#FFFFFF',
              transition: 'all 100ms ease-in-out',
              '&:hover': {
                boxShadow: '2px 2px 0px #1e1e1e',
                transform: 'translate(2px, 2px)',
              },
            }}
          >
            <Typography sx={{ fontSize: '2rem', mb: 2 }}>
              {feature.icon}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Montserrat, sans-serif',
                fontWeight: 700,
                fontSize: '1.05rem',
                color: '#2C2C2C',
                mb: 1,
              }}
            >
              {feature.title}
            </Typography>
            <Typography
              sx={{
                fontFamily: 'Lato, sans-serif',
                fontSize: '0.9rem',
                color: '#555',
                lineHeight: 1.7,
              }}
            >
              {feature.description}
            </Typography>
          </Box>
        ))}
      </Box>
    </Section>
  );
}
